import type { SelectOption, SelectOptionWithAttributes } from '../../../../../types';

const PARENT = 'FullTextLicense';
const CHILD = 'LicenseTextAppendix';

const hasFullLicenseText = (values: SelectOption[]): boolean => values.some(({ value }) => value === PARENT);

/**
 * The appendix only makes sense when Full License Text is on, so its checkbox is disabled until the parent is checked.
 */
export function nestLicenseTextAppendixOption(
  options: SelectOptionWithAttributes[],
  values: SelectOption[],
): SelectOptionWithAttributes[] {
  const isParentChecked = hasFullLicenseText(values);
  return options.map((option) => option.value === CHILD ? { ...option, isDisabled: !isParentChecked } : option);
}

/**
 * Drops the appendix value when Full License Text is not selected, so unchecking the parent also unchecks the child.
 */
export function dropOrphanedLicenseTextAppendix(values: SelectOption[]): SelectOption[] {
  return hasFullLicenseText(values) ? values : values.filter(({ value }) => value !== CHILD);
}

export const isLicenseTextAppendixOption = (option: SelectOption): boolean => option.value === CHILD;
